module.exports = __webpack_public_path__ + "static/media/icon_search_click.e7b83ae7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_search_click.svg
// module id = 232
// module chunks = 0